import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import Moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { putPoSyncExceptionErrorList,getPoSyncExceptionError } from "../Actions/POViewAPI";

let searchData= {
  ShipName: "",
  PageNumber: 1,
  PageSize: 25,
};

let userkey = JSON.parse(localStorage.getItem("currentUser"));

class POCommonCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }

  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;
    return (
      <div className="" style={{ paddingTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <Paginator
            className="mb-3"
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                {" "}
                !--No Item to Display--!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  ClosePoSyncError = (item) => {
    const { dispatch } = this.props;
    confirmAlert({
      message: "Are you sure want to close ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let data = {
              id: item?.id ? item?.id : 0,
              shipId: item?.shipId,
              shipName: item?.clientShipName ? item?.clientShipName : "",
              poPullDate: item?.poPullDate ? item?.poPullDate : "",
              poNumber: item?.poNumber ? item?.poNumber : "",
              type: item?.type,
              modifiedBy: userkey.email,
              status: "closed",
            };
           let url = `${API.POSyncException}`;
           axios
              .put(url, data)
              .then((response) => {
                if(response.data==="Succesfully Updated"){
                dispatch(getPoSyncExceptionError(searchData));
                toast.success("Closed Successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                dispatch({
                  type: "updatePOSyncExceptionInfoSuccess",
                  data: response.data,
                });
              }
              })
              .catch((error) => {
                dispatch({
                  type: "updatePOSyncExceptionInfoFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  UpdatePoSyncError = (item) => {
    const { dispatch } = this.props;
    confirmAlert({
      message: "Are you sure want to update the shipname and populldate ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let data = {
              id: item?.id ? item?.id : 0,
              shipId: item?.shipId,
              shipName: item?.clientShipName ? item?.clientShipName : "",
              poPullDate: item?.poPullDate ? item?.poPullDate : "",
              poNumber: item?.poNumber ? item?.poNumber : "",
              type: item?.type,
              modifiedBy: userkey.email,
              status: "updated",
            };
            dispatch(putPoSyncExceptionErrorList(data));
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, DeleteKeyword } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
          return item?.type ===
            "error"  && item?.status !== "closed" ? (
            <div
              className="card"
              style={{ overflow: "hidden", position: "relative" }}
            >
              <div className="p-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div
                      className={
                        "col-md-10 col-sm-12 col-12 col-lg-10 col-m-auto"
                      }
                    >
                      <div className="row px-3">
                        <div className="col-sm-12 mb-2">
                          <h6 className="resource-list-title m-auto">
                            <span>
                              <strong>Error : </strong>
                              <span className="italicFont">
                                Ship name mismatching{" "}
                              </span>
                            </span>
                          </h6>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>Our Ship Name : </strong>
                            <span className="italicFont">
                              {item.ourShipName}{" "}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>Client Ship Name : </strong>
                            <span className="italicFont">
                              {item.clientShipName}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>PO Pull Date : </strong>
                            <span className="italicFont">
                              {item.poPullDate
                                ? Moment(
                                    new Date(Date.parse(item.poPullDate))
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>Po Sync Date : </strong>
                            <span className="italicFont">
                              {item.poPullDate
                                ? Moment(
                                    new Date(Date.parse(item.syncDate))
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        "col-12 col-sm-12 col-md-2 col-lg-2 col-m-auto"
                      }
                    >
                      <div className="text-center col-m-auto">
                        <div className="search-btn-col">
                          {item.status === "pending" ? (
                            <button
                              className="btn update-button text-uppercase txtside-btn txtht-btn italicFont"
                              onClick={() => this.UpdatePoSyncError(item)}
                            >
                              update
                            </button>
                          ) : item.status === "updated" ? (
                            <button
                              className="btn close-button text-uppercase txtside-btn txtht-btn italicFont"
                              onClick={() => this.ClosePoSyncError(item)}
                            >
                              CLOSE
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : item.type === "info" && item.status !== "closed" ? (
            <div
              className="card"
              style={{ overflow: "hidden", position: "relative" }}
            >
              <div className="p-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div
                      className={
                        "col-md-10 col-lg-10 col-sm-12 col-12 col-m-auto"
                      }
                    >
                      <div className="row px-3">
                        <div className="col-sm-12 mb-2">
                          <h6 className="resource-list-title m-auto">
                            <span>
                              <strong>Info : </strong>
                              <span className="italicFont">Duplicate PO</span>
                            </span>
                          </h6>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>PO Number : </strong>
                            <span className="italicFont">{item.poNumber} </span>
                          </span>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong> Ship Name : </strong>
                            <span className="italicFont">
                              {item.ourShipName}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>PO Pull Date : </strong>
                            <span className="italicFont">
                              {item.poPullDate
                                ? Moment(
                                    new Date(Date.parse(item.poPullDate))
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-4 mb-1">
                          <span>
                            <strong>Po Sync Date : </strong>
                            <span className="italicFont">
                              {item.poPullDate
                                ? Moment(
                                    new Date(Date.parse(item.syncDate))
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        "col-sm-12 col-md-2 col-lg-2 col-m-auto col-12"
                      }
                    >
                      <div className="text-center col-m-auto">
                        <div className="search-btn-col">
                          <button
                            className="btn close-button text-uppercase txtside-btn txtht-btn italicFont"
                            onClick={() => this.ClosePoSyncError(item)}
                          >
                            close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null;
        })
      : null;
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(POCommonCard)
);
